import { validate } from "jsonschema"

import CLICK_ATTRIBUTES from "modules/analytics/schema/clickAttributes"
import IDENTIFY_ATTRIBUTES from "modules/analytics/schema/identifyAttributes"
import LOG_ATTRIBUTES from "modules/analytics/schema/logAttributes"
import PAGEVIEW_ATTRIBUTES from "modules/analytics/schema/pageviewAttributes"
import USER_ATTRIBUTES from "modules/analytics/schema/userAttributes"
import VIEW_ATTRIBUTES from "modules/analytics/schema/viewAttributes"
import { isDevelopment } from "utils/environment"
import EVENTS from "./events"

const ATTRIBUTE_SCHEMAS = {
  [EVENTS.click]: CLICK_ATTRIBUTES,
  [EVENTS.identify]: IDENTIFY_ATTRIBUTES,
  [EVENTS.pageview]: PAGEVIEW_ATTRIBUTES,
  [EVENTS.setUserAttributes]: USER_ATTRIBUTES,
  [EVENTS.view]: VIEW_ATTRIBUTES,
  [EVENTS.log]: LOG_ATTRIBUTES,
}

function areAttributesValid(type, attributes) {
  const schema = ATTRIBUTE_SCHEMAS[type]
  if (!schema) throw new Error(`Attributes schema is not defined for ${type}`)

  const result = validate(attributes, schema, { required: true })

  if (!result.valid && isDevelopment()) {
    // eslint-disable-next-line no-console
    console.error(
      `analytics: Attributes passed for "${type}" event are not valid. Found the following issues:\n`,
      result.errors.map((o, i) => `${i + 1}. ${o.property} ${o.message}`).join("\n")
    )
  }
  return result.valid
}

export default areAttributesValid
